<template>
  <div />
</template>
<script>
import store from '@/components/facet/store'
import pageRefresh from '@/components/facet/page-refresh'

export default {
  data() {
    return {
      store
    }
  },
  watch: {
    'store.state.tags': {
      handler() {
        this.emptyServerRenderedContainer()
      }
    },
    'store.state.searchTerms': {
      handler() {
        this.emptyServerRenderedContainer()
      }
    }
  },
  mounted() {
    this.$blocksContainer = document.querySelector('.js-facet-blocks-container')
    this.facetGroupBlock()
  },
  methods: {
    emptyServerRenderedContainer() {
      this.$blocksContainer.remove()
    },
    async facetGroupBlock() {
      this.$blocksContainer.querySelectorAll('.js-facet-group-block').forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()
          const tags = JSON.parse(item.dataset.model)
          this.store.dispatch('showLoader')
          this.store.dispatch('setTags', { tags })
          pageRefresh.updatePage()
        })
      })
    }
  }
}
</script>
